// hooks/useConversationStatus.js
import { useState, useEffect } from 'react'
import { doc, onSnapshot } from 'firebase/firestore'
import { db } from '../firebase' // passe Pfad an

export function useConversationStatus (conversationId, companyId) {
  const [status, setStatus] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    console.log('Setting up status listener for conversation:', conversationId)
    if (!conversationId || !companyId) {
      setStatus(null)
      setIsLoading(false)
      return
    }

    const docRef = doc(
      db,
      `companies/${companyId}/conversations`,
      conversationId
    )

    const unsub = onSnapshot(
      docRef,
      snap => {
        if (snap.exists()) {
          const data = snap.data()
          setStatus(data.currentStatus || null)
          console.log('Current status:', data.currentStatus)
          setIsLoading(false)
        } else {
          setStatus(null)
          setIsLoading(false)
        }
      },
      error => {
        console.error('Status listener error:', error)
        setIsLoading(false)
      }
    )

    return () => unsub()
  }, [conversationId, companyId])

  return { status, isLoading }
}
